import { AppManifest, ViewInstance, PanelEnum } from './types';
import { voLogger } from '@shared/utils/logger';

const log = voLogger('app:controller');
export abstract class BaseAppController {
  protected manifest: AppManifest;
  protected store: {
    // Define store structure
    mountView: (panel: PanelEnum, viewName: string) => void;
    unmountView: (panel: PanelEnum, viewId: string) => void;
    getViewsForPanel: (panel: PanelEnum) => ViewInstance[];
  };

  constructor(manifest: AppManifest, store: any) {
    this.manifest = manifest;
    this.store = store;
  }

  /** Mount a view into a specific panel */
  mountView(panel: PanelEnum, viewName: string) {
    const views = this.manifest.views.filter((view) => view.allowedPanels?.includes(panel));
    const view = views.find((view) => view.slug === viewName);

    if (view) {
      this.store.mountView(panel, viewName);
      log(`[${this.manifest.uuid}] Mounted ${viewName} in ${panel}`);
    } else {
      log(`[${this.manifest.uuid}] View ${viewName} not found in panel ${panel}`);
    }
  }

  /** Unmount a view from a panel */
  unmountView(panel: PanelEnum, viewId: string) {
    this.store.unmountView(panel, viewId);
    console.log(`[${this.manifest.uuid}] Unmounted ${viewId} from ${panel}`);
  }

  /** Retrieve all views mounted in a panel */
  getViewsForPanel(panel: PanelEnum): ViewInstance[] {
    return this.store.getViewsForPanel(panel);
  }

  /** Retrieve all available views from the manifest */
  getAvailableViews() {
    return this.manifest.views;
  }

  /** Abstract method for app-specific initialization */
  abstract onAppReady(): void;
}
